import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import RegistersEditor from "./RegistersEditor";
import { useAuthenticatedRequest } from "./hooks/useAuthenticatedRequest";

const RegistersEditorPage = () => {
  const { registerId } = useParams();
  const navigate = useNavigate();
  const { get, post, put } = useAuthenticatedRequest();
  const [register, setRegister] = useState(null);
  const [loading, setLoading] = useState(true);

  const isNew = registerId === "new";

  const createEmptyRegister = () => ({
    _id: crypto.randomUUID(),
    name: "",
    type: "",
    description: "",
    asOfDateTime: new Date().toISOString(),
    isDefinitionLibrary: false,
    entries: [],
    createdDate: new Date().toISOString(),
  });

  useEffect(() => {
    const fetchRegister = async () => {
      if (isNew) {
        setRegister(createEmptyRegister());
        setLoading(false);
      } else {
        try {
          const response = await get(`https://registers.poc.mrc.ai/api/registers/${registerId}`);
          setRegister(response.data);
        } catch (error) {
          console.error("Error fetching register:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchRegister();
  }, [registerId, isNew]);

  const handleSave = async (updatedRegister) => {
  try {
    const url = isNew
      ? `https://registers.poc.mrc.ai/api/registers`
      : `https://registers.poc.mrc.ai/api/registers/${registerId}`;

    const response = isNew
      ? await post(url, updatedRegister)
      : await put(url, updatedRegister);

    setRegister(response.data);
  } catch (err) {
    console.error("Error saving register:", err);
  }
};

  const handleClose = () => navigate("/");

  if (loading) return <Spinner />;

  return <RegistersEditor register={register} onClose={handleClose} isNew={isNew} />;
};

export default RegistersEditorPage;
